export default "__VITE_ASSET__oo3vkZbg$oFIiT8$lRAxcA__";